import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { InViewportModule } from 'ng-in-viewport';
import { SimpleSpinnerComponent } from './components/simple-spinner/simple-spinner.component';
import { CenteredSpinnerComponent } from './components/centered-spinner/centered-spinner.component';
import { UserPicturePreloaderComponent } from './components/user-picture-preloader/user-picture-preloader.component';

@NgModule({
  declarations: [SimpleSpinnerComponent, CenteredSpinnerComponent, UserPicturePreloaderComponent],
  exports: [SimpleSpinnerComponent, CenteredSpinnerComponent, UserPicturePreloaderComponent],
  imports: [CommonModule, MatProgressSpinnerModule, InViewportModule],
})
export class PwSpinnerModule {}
